import { Component } from '@angular/core';
import * as Chartist from 'chartist';
import { DashboardService } from '../../services/dashboard/dashboard.service';
import { DatePipe } from "@angular/common";
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS
} from "@angular/material";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { default as _rollupMoment, Moment,} from 'moment';
import { FormControl } from '@angular/forms';
import {MatDatepicker} from '@angular/material/datepicker';
import { Dashboard } from '../../models/Dashboard';
import { environment } from 'environments/environment';

const moment = _rollupMoment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MMM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-kpi5-dashboard',
  templateUrl: './kpi5.component.html',
  styleUrls: ['./kpi5.component.css'],
  providers:[DatePipe,
    {
    provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE]
  },

  { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class Kpi5Component{

  date = new FormControl(moment());
  totalCartera:any=0;
  dataactual:any;
  disponible:any = 20.00;
  monedaElement : any = 1255;
  loading: boolean = false;
  disable: boolean = false;
  simbolo: any = '';
  datarandom: any={
    '202411':
    {
      '1255':[{
        dia:"0-29",
        cartera:19.5,
        util:1
      },{ 
        dia:"30-59",
        cartera:18.5,
        util:8 
      },{ 
        dia:"60-89",
        cartera:14.5,
        util:2 
      },{ 
        dia:"90-119",
        cartera:18.6,
        util:3 
      },{ 
        dia:"120-180",
        cartera:16.4,
        util:9 
      },{ 
        dia:">180",
        cartera:1.8,
        util:12 
      }],
      '1447':
      [{
        dia:"0-29",
        cartera:2.5,
        util:2,
        acum:0
      },{ 
        dia:"30-59",
        cartera:1.5,
        util:5 
      },{ 
        dia:"60-89",
        cartera:0.5,
        util:2 
      },{ 
        dia:"90-119",
        cartera:0.6,
        util:3 
      },{ 
        dia:"120-180",
        cartera:0.4,
        util:2 
      },{ 
        dia:">180",
        cartera:1.8,
        util:12 
      }]

    }, 
    '202410':
    {
      '1447':[{
        dia:"0-29",
        cartera:19.5,
        util:1
      },{ 
        dia:"30-59",
        cartera:18.5,
        util:8 
      },{ 
        dia:"60-89",
        cartera:14.5,
        util:2 
      },{ 
        dia:"90-119",
        cartera:18.6,
        util:3 
      },{ 
        dia:"120-180",
        cartera:16.4,
        util:9 
      },{ 
        dia:">180",
        cartera:1.8,
        util:12 
      }],
      '1255':
      [{
        dia:"0-29",
        cartera:2.5,
        util:2,
        acum:0
      },{ 
        dia:"30-59",
        cartera:1.5,
        util:5 
      },{ 
        dia:"60-89",
        cartera:0.5,
        util:2 
      },{ 
        dia:"90-119",
        cartera:0.6,
        util:3 
      },{ 
        dia:"120-180",
        cartera:0.4,
        util:2 
      },{ 
        dia:">180",
        cartera:1.8,
        util:12 
      }]

    }, 
  }
    
  ;
  constructor(private dashboardService:DashboardService,private datePipe: DatePipe) { }
  
  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    ctrlValue.year(normalizedMonth.year());
    this.date.setValue(ctrlValue);
    datepicker.close();
    this.getrandom(this.datePipe.transform(this.date.value._d,'yyyyMM'),this.monedaElement);
    //this.obtenerDashboardFecha();
  }
  startAnimationForLineChart(chart){
      let seq: any, delays: any, durations: any;
      seq = 0;
      delays = 80;
      durations = 500;

      chart.on('draw', function(data) {
        if(data.type === 'line' || data.type === 'area') {
          data.element.animate({
            d: {
              begin: 600,
              dur: 700,
              from: data.path.clone().scale(1, 0).translate(0, data.chartRect.height()).stringify(),
              to: data.path.clone().stringify(),
              easing: Chartist.Svg.Easing.easeOutQuint
            }
          });
        } else if(data.type === 'point') {
              seq++;
              data.element.animate({
                opacity: {
                  begin: seq * delays,
                  dur: durations,
                  from: 0,
                  to: 1,
                  easing: 'ease'
                }
              });
          }
      });

      seq = 0;
  };
  startAnimationForBarChart(chart){
      let seq2: any, delays2: any, durations2: any;

      seq2 = 0;
      delays2 = 80;
      durations2 = 500;
      chart.on('draw', function(data) {
        if(data.type === 'bar'){
            seq2++;
            data.element.animate({
              opacity: {
                begin: seq2 * delays2,
                dur: durations2,
                from: 0,
                to: 1,
                easing: 'ease'
              }
            });
        }
      });

      seq2 = 0;
  };
  ngOnInit() {
       
      this.getrandom(this.datePipe.transform(this.date.value._d,'yyyyMM'),this.monedaElement);

       

  }
  sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
  async getrandom(periodo,monedaElement){
    this.loading = true;
    await this.sleep(3000);
    this.loading = false; 
    var datawebsiteViewsChart:any={labels: [],series:[]};
    var datawebsiteViewsChart2:any={labels: [],series:[]};
    this.dataactual = this.datarandom[periodo][monedaElement];
    this.simbolo = (this.monedaElement == 1447)? '(MM)':'(k)';    
    let smb = this.simbolo;
    let serie1: any=[]
    let serie2: any=[]
    var acumtotal:any=0;
    this.dataactual.forEach(element => { 
      acumtotal+= element.cartera;
    });
    for (let index = 0; index < this.dataactual.length; index++) { 
       this.dataactual[index].util = (this.dataactual[index].cartera/acumtotal*100);
    } 
    this.dataactual.forEach(element => {
      datawebsiteViewsChart.labels.push(element.dia);
      //datawebsiteViewsChart2.labels.push(element.dia);
      this.totalCartera+= element.cartera;
      serie1.push(element.cartera);
      serie2.push(element.util);
      datawebsiteViewsChart2.series.push(element.util);
    });
    datawebsiteViewsChart.series.push(serie1);
    //datawebsiteViewsChart2.series.push(serie1);
     
    

    var optionswebsiteViewsChart = {
        axisX: {
            showGrid: false
        },
        axisY: {   
          labelInterpolationFnc: function(value) {
            return Math.floor(value) + smb; 
          },
          high: 30
        },
        low: 0, 
        height: 400,
        chartPadding: { top: 5, right: 5, bottom: 5, left: 20},
        barWidth: 40,
    };
    
    var sum = function(a, b) { return a + b };
    const optionswebsiteViewsChart2: any = {
      lineSmooth: Chartist.Interpolation.cardinal({
          tension: 0
      }), 
      labelInterpolationFnc: function(value) {
        return Math.round(value / datawebsiteViewsChart2.series.reduce(sum) * 100) + '%';
      },
      low: 0,
      width: 400,
      height: 400, 
    }
    var responsiveOptions: any[] = [
      
    ];
    var websiteViewsChart = new Chartist.Bar('#websiteViewsChart', datawebsiteViewsChart, optionswebsiteViewsChart, responsiveOptions);

    //start animation for the Emails Subscription Chart
    this.startAnimationForBarChart(websiteViewsChart);

    
    var websiteViewsChart2 = new Chartist.Pie('#websiteViewsChart2', datawebsiteViewsChart2, optionswebsiteViewsChart2);

    //start animation for the Emails Subscription Chart
    this.startAnimationForBarChart(websiteViewsChart2);
  }
  tipoMoneda(event){
    this.monedaElement = event;
    this.getrandom(this.datePipe.transform(this.date.value._d,'yyyyMM'),this.monedaElement);
  }
}
